module.exports = __webpack_public_path__ + "static/img/dizhi.a8b76c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/dizhi.png
// module id = 9AnW
// module chunks = 1